import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { notificationEventsActionType } from '../actions/actionTypes';

export const REDUCER_NAME = 'EventsFilterList';

const updateFilterConfig = (state, action) => {
  if (action.data.systemDefault) {
    return {
      ...state,
      selectedFilter: action.data.selectedItem || null,
      systemDefaultFilter: action.data.systemDefault || null,
      userDefaultFilter: action.data.userDefault || null,
    };
  }
  if (action.data.userDefault === null || action.data.userDefault) {
    return {
      ...state,
      selectedFilter: action.data.selectedItem || null,
      userDefaultFilter: action.data.userDefault,
    };
  }
  return {
    ...state,
    selectedFilter: action.data.selectedItem || null,
  };
};

const logAccOptsListReq = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const updateTableConfig = (state, action) => ({
  ...state,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  listColumnOrder: action.data ? action.data.detail.columnOrders : null,
  selectedFilter: action.data ? action.data : null,
});

function EventsFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // config list column configuration
    case notificationEventsActionType.UPDATE_NOTIF_EVENTS_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case notificationEventsActionType.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case notificationEventsActionType.REMOVE_NOTIF_EVENTS_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    default:
      return null;
  }
}

function EventsFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // log request
    case notificationEventsActionType.LOG_NOTIF_EVENTS_LIST_REQUEST:
      return logAccOptsListReq(state, action);
    // log error
    case notificationEventsActionType.GET_NOTIF_EVENTS_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    // store response
    case notificationEventsActionType.GET_NOTIF_EVENTS_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case notificationEventsActionType.GET_NOTIF_EVENTS_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case notificationEventsActionType.RESET_NOTIF_EVENTS_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case notificationEventsActionType.GET_NOTIFICATION_ADDCONC_ERROR:
      return {
        ...state,
        concRequestError: action.data,
        loading: false,
      };
    case notificationEventsActionType.GET_NOTIFICATION_LIST_RESPONSE:
      return {
        ...state,
        notifData: action.data,
        loading: false,
      };
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}
const EventsFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = EventsFilterListConfig(state, action);
  const stateReqRes = EventsFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default EventsFilterList;
